import { format } from '@/utils/StringUtilities'

// 1) Pokud je v jakemkoli datasetu dvojice (InstitutionId, ReportTemplateVersionId), pak musi byt i v ostatnich Datasetech
const validateInstitutionReportTemplatePresence = (datasets, errorMessageFormat, locale) => {
  if (datasets && datasets.length > 1) {
    let datasetIndex = 0
    while (datasetIndex < datasets.length) {
      const dataset1 = datasets[datasetIndex]
      for (let i = datasetIndex + 1; i < datasets.length; i++) {
        const dataset2 = datasets[i]

        // compare first dataset with second
        let result = compareDatasets(dataset1, dataset2, errorMessageFormat)
        if (result) { return result }

        // and now compare second dataset with the first one
        result = compareDatasets(dataset2, dataset1, errorMessageFormat)
        if (result) { return result }
      }
      datasetIndex++
    }
  }
  return null
}

const compareDatasets = (dataset1, dataset2, errorMessageFormat, locale) => {
  for (let x = 0; x < dataset1.reportSubmissionGroups.length; x++) {
    const reportSubmissionGroup = dataset1.reportSubmissionGroups[x]

    const { institutionId, institutionName, institutionLatinName } = reportSubmissionGroup
    for (let i = 0; i < reportSubmissionGroup.reportTemplates.length; i++) {
      const template = reportSubmissionGroup.reportTemplates[i]
      if (!containsCombination(dataset2.reportSubmissionGroups, { institutionId, reportTemplateVersionId: template.id })) {
        return format(
          errorMessageFormat,
          (locale === 'ar' ? template.name : template.latinName),
          (locale === 'ar' ? institutionName : institutionLatinName),
          dataset2.index
        )
      }
    }
  }
  return null
}

const containsCombination = (reportSubmissionGroups, { institutionId, reportTemplateVersionId }) => {
  for (var x = 0; x < reportSubmissionGroups.length; x++) {
    const reportSubmissionGroup = reportSubmissionGroups[x]

    if (reportSubmissionGroup.institutionId === institutionId) {
      if (reportSubmissionGroup.reportTemplates.find(x => x.id === reportTemplateVersionId)) { return true }
    }
  }
  return false
}

export {
  validateInstitutionReportTemplatePresence
}



// WEBPACK FOOTER //
// ./src/internal-app/pages/outputReportGenerator/validation/validateInstitutionReportTemplatePresence.js